import { TargettedSystems } from 'nots-window-renderer';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ComposedActions } from '../../helpers/actions';
import TabContent from '../common-components/Tab/TabContent';
import WindowDisplayManager from '../common-components/WindowDisplayManager';
import * as CatizColors from './Colors';
import GlobalTab, { tabs } from './GlobalTab';
import WindowHeader from './WindowHeader';

const EachTabHead = styled.div<any>`
  text-transform: uppercase;
  padding: 4px 10px;
  border: solid 1px black;
  font-size: 12px;
  > span {
    cursor: pointer;
  }
  ${({ isActive }) => `
    border-bottom-style: ${isActive ? 'none' : 'solid'};
    background: ${isActive ? CatizColors.lightBlue : CatizColors.deepBlue}
  `}
`;
export const TabHeaderContainer = styled.div`
  display: flex;
`;

const CloseIcon = styled.div`
  width: 8px;
  height: 8px;
  border: solid 1px white;
  display: inline-block;
  margin: auto 0;
  margin-left: 8px;
  cursor: pointer;
`;

export const TabContentContainer = styled.div`
  background: ${CatizColors.lightBlue};
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: 17px 24px auto;
`;

const GLOBAL_TAB = 'global';

const TabIdToLabelMap = tabs.reduce(
  (acc: any, item: any) => {
    return {
      ...acc,
      [item.id]: item.label,
    };
  },
  { [GLOBAL_TAB]: 'GLOBAL' }
);
export default function TabPanel() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(GLOBAL_TAB);
  const statusArea = useSelector(
    (state: any) => state.executor.catiz.statusAreaTabs
  );
  const storeActiveTab = useSelector(
    (state: any) => state.executor.catiz.activeTab
  );

  useEffect(() => {
    const tabs = Object.keys(statusArea);
    const newArr: Array<any> = [];
    newArr.push({
      key: GLOBAL_TAB,
      isActive: storeActiveTab === '' || storeActiveTab === GLOBAL_TAB,
    });
    tabs.forEach((tab) => {
      newArr.push({
        key: tab,
        window: statusArea[tab].window,
        isActive: storeActiveTab === tab,
      });
    });

    setTabHeaders(newArr);
    setActiveTab(storeActiveTab);
  }, [statusArea, storeActiveTab]);
  const [tabHeaders, setTabHeaders] = useState([
    { key: GLOBAL_TAB, isActive: false, default: true, label: 'GLOBAL' },
  ]);
  const onTabClick = (key: string) => {
    dispatch(
      ComposedActions.ActivateCatizTab.aCreator({
        tabTitle: key,
      })
    );
  };
  return (
    <Container>
      <WindowHeader name={'Status Area'} />
      <TabHeaderContainer>
        {tabHeaders.map((tabHead) => {
          return (
            <TabHeader
              key={tabHead.key}
              item={tabHead.key}
              isDefault={!!tabHead.default}
              isActive={activeTab === tabHead.key}
              onClick={onTabClick}
            ></TabHeader>
          );
        })}
      </TabHeaderContainer>
      <TabContentContainer>
        <TabContent tabValue={GLOBAL_TAB} currValue={activeTab}>
          <GlobalTab />
        </TabContent>
        {tabHeaders
          .filter((tab) => tab.key !== GLOBAL_TAB)
          .map((header) => {
            return (
              <TabContent
                key={header.key}
                tabValue={header.key}
                currValue={activeTab}
              >
                <WindowDisplayManager
                  area={header.key}
                  targetSystem={TargettedSystems.CATIZ}
                />
              </TabContent>
            );
          })}
      </TabContentContainer>
    </Container>
  );
}

function TabHeader({
  item,
  isDefault,
  isActive,
  onClick,
}: {
  item: string;
  isDefault: boolean;
  isActive: boolean;
  onClick: (key: string) => void;
}) {
  return (
    <EachTabHead isActive={isActive}>
      <span id={item} onClick={() => onClick(item)}>
        {TabIdToLabelMap[item]}
      </span>
      {!isDefault && <CloseIcon />}
    </EachTabHead>
  );
}
